/**
 * Valid comparison operator values for our own CaseArrestsFilter.
 * These are defined by us in CaseArrestsFilter.php!
 */
export enum CaseArrestsFilterComparison {
  GREATER_THAN = 'gt',
  LESS_THAN = 'lt',
  EQUAL_TO = 'equal',
}
